import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const SmallStatisticItemWrapper = styled(Box)`
  display: table;
  border-spacing: ${({theme}) => `0px ${theme.spacing(1)}`};
`;
